import { useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';
import { storeOAuthState } from '../utils/oauth';

const GMAIL_AUTH_ENDPOINT = 'https://accounts.google.com/o/oauth2/v2/auth';
const SCOPES = [
  'https://www.googleapis.com/auth/gmail.readonly',
  'https://www.googleapis.com/auth/userinfo.email'
].join(' ');

export function useGmailAuth() {
  const { user } = useAuth();

  const initiateAuth = useCallback(async () => {
    if (!user) return;
    
    const state = crypto.randomUUID();
    await storeOAuthState(user.id, state);
    
    const params = new URLSearchParams({
      client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
      redirect_uri: `${window.location.origin}/auth/gmail/callback`,
      response_type: 'code',
      scope: SCOPES,
      access_type: 'offline',
      prompt: 'consent',
      state
    });

    window.location.href = `${GMAIL_AUTH_ENDPOINT}?${params.toString()}`;
  }, [user]);

  return { initiateAuth };
}